import { render, staticRenderFns } from "./ProductivityManagement.vue?vue&type=template&id=aeb23e2a&"
import script from "./ProductivityManagement.vue?vue&type=script&lang=js&"
export * from "./ProductivityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports